import { getAppVersion } from '@/api/modules/app';
import { Message } from '@arco-design/web-react';
import { makeAutoObservable, action, toJS, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
interface updateInfoProps {
  id: number;
  version: string;
  timestamp: number;
  remark?: string;
  win_download_url: string;
  mac_download_url: string;
  is_mandatory_update?: boolean;
  created_at: number;
  updated_at: number;
}
class Store {
  isUpdate = false;
  version = '0';
  isSkip = false;
  isShow = false;
  upgradeVisible = false;
  promptly = false;
  updateInfo: updateInfoProps;
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'ClientUpdate',
      properties: ['isUpdate', 'version', 'isSkip'],
      storage: window.localStorage,
    });
  }
  @action setUpdateStatus = (status) => {
    this.isShow = status;
    this.isUpdate = status;
  };
  @action setIsShow = (status) => {
    this.isShow = status;
  };
  @action setIsSkip = (status) => {
    this.isSkip = status;
  };
  @action setIsPromptly = (status) => {
    this.promptly = status;
  };
  @action setUpdateInfo = (data) => {
    console.log('this.version========>', this.version);
    this.updateInfo = data;
    runInAction(() => {
      if (data) this.setUpdateStatus(data?.version !== this.version);
    });
  };
  @action setUpgradeVisible = (v) => {
    this.upgradeVisible = v;
  };

  @action setVersion = (version) => {
    this.version = version;
  };

  @action checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };

  @action checkIsLatestVersion = async () => {
    const res = await getAppVersion();
    ClientUpdate.setUpdateInfo(res.data.rows);
    console.log(res.data.rows, this.version);
    return res.data.rows?.version === this.version;
  };

  @action update = async () => {
    if (window.electron) {
      const isMac = this.checkAppleSystem();
      window.electron.ipcRenderer.downloadUpdate({
        url: isMac
          ? this.updateInfo.mac_download_url
          : this.updateInfo.win_download_url,
        isMandatory: true,
      });
      this.setIsShow(false);
      this.setIsPromptly(false);
      this.setUpgradeVisible(true);
    }
  };
}

const ClientUpdate = new Store();
export default ClientUpdate;
